import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Track page views on route changes (SPA)
  useEffect(() => {
    if (GA_ID && typeof window.gtag === 'function') {
      window.gtag('config', GA_ID, { page_path: pathname });
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
